import angular from 'angular';

export default function escapeHtml() {
  return (html) => {
    if (!html || !angular.isString(html)) {
      return html;
    }

    return html.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;')
        .replace(/\//g, '&#x2F;');
  };
}